module.exports = __webpack_public_path__ + "static/berrettini-red-79235ea71fbd5ab3f2b862210d361010.png";